import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { SEOHead } from "@components/organisms";
import { Button, Text } from "@components/atoms";
import { ROUTES } from "@shared/constants";
import { esRetornoDeInscripcionHyrun, urlDeRetornoHyrun } from "../hyrunReturn";

/**
 * Payment cancel page.
 * PayPhone redirects here when the user cancels the payment.
 * URL: /payment/cancel
 */
export function PaymentCancelPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Cancelar en la cajita trae a la persona acá por la misma razón que el retorno: PayPhone usa la
  // URL configurada en la tienda, no la que se le pasa. Ver `hyrunReturn.ts`.
  //
  // Solo se rebota si PayPhone mandó el `clientTransactionId`; si no vino, no hay con qué saber de
  // quién es la vuelta y mandar a la landing a un comprador de entradas sería peor que dejarlo acá.
  // Acá no hay cobro de por medio, así que el caso sin parámetro no pierde nada.
  const esDeHyrun = esRetornoDeInscripcionHyrun(searchParams.get("clientTransactionId"));
  useEffect(() => {
    if (esDeHyrun) window.location.replace(urlDeRetornoHyrun(window.location.search, true));
  }, [esDeHyrun]);

  const handleRetry = () => {
    navigate(-1); // Go back to previous page (event detail)
  };

  const handleGoHome = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <>
      <SEOHead title="Pago Cancelado" noIndex />
      <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-neutral-60 to-primary-110 px-4">
        <div className="flex w-full max-w-md flex-col items-center gap-6 rounded-2xl bg-white p-8 shadow-lg">
          <XCircle size={80} className="text-orange-500" />

          <Text variant="h3" as="h1" className="text-center text-black">
            Pago cancelado
          </Text>

          <Text variant="body" className="text-center text-neutral-110">
            Has cancelado el proceso de pago. No se ha realizado ningún cargo a
            tu cuenta.
          </Text>

          <div className="flex w-full flex-col gap-3 pt-4">
            <Button
              className="w-full h-12 bg-primary-110 text-white hover:bg-primary-100"
              onClick={handleRetry}
            >
              Intentar de nuevo
            </Button>
            <Button
              className="w-full h-12 bg-transparent border border-primary-110 text-primary-110 hover:bg-primary-110/10"
              onClick={handleGoHome}
            >
              Volver al inicio
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
